import { __assign, __spreadArrays } from "tslib";
import { getUrlMatches } from '../urlValidators';
export var linkify = function (contentState, _a) {
    var anchorTarget = _a.anchorTarget, relValue = _a.relValue;
    return contentState.blocks.reduce(function (state, block) {
        var text = block.text;
        var linkEntries = getUrlMatches(text)
            .filter(function (_a) {
            var url = _a.text, start = _a.index, end = _a.lastIndex;
            var alreadyHasEntity = hasEntityInRange(block, start, end);
            var longEnough = url.length >= 6;
            return !alreadyHasEntity && longEnough;
        })
            .map(function (_a, idx) {
            var url = _a.text, start = _a.index, end = _a.lastIndex;
            return createEntity(Object.keys(state.entityMap).length + idx, url, start, end, anchorTarget, relValue);
        });
        return {
            blocks: __spreadArrays(state.blocks, [
                __assign(__assign({}, block), { entityRanges: __spreadArrays(block.entityRanges, linkEntries.map(function (_a) {
                        var entityRange = _a.entityRange;
                        return entityRange;
                    })) }),
            ]),
            entityMap: __assign({}, linkEntries.reduce(function (entityMap, _a) {
                var mapEntry = _a.mapEntry;
                return (__assign(__assign({}, entityMap), mapEntry));
            }, state.entityMap)),
        };
    }, { blocks: [], entityMap: __assign({}, contentState.entityMap) });
};
var hasEntityInRange = function (block, start, end) {
    return block.entityRanges.some(function (_a) {
        var offset = _a.offset, length = _a.length;
        return start < offset + length && end >= offset;
    });
};
var createEntity = function (entityKey, url, start, end, anchorTarget, relValue) {
    var _a;
    var entityRange = {
        offset: start,
        length: end - start,
        key: entityKey,
    };
    var mapEntry = (_a = {},
        _a[entityKey] = {
            type: 'LINK',
            mutability: 'MUTABLE',
            data: {
                url: url,
                target: anchorTarget || '_blank',
                rel: relValue || 'noopener',
            },
        },
        _a);
    return { entityRange: entityRange, mapEntry: mapEntry };
};
//# sourceMappingURL=linkify.js.map